export enum SupportRequestInitialStatusEnum {
  PendingFirstReview = 1,
  PendingExceptionsCommitteeApproval = 2,
  PendingCompletion = 3,
  PendingManagementApproval = 4,
  Approved = 5,
  Rejected = 6,
  Cancelled = 7,
  CompletionReturned = 8,
}
